

<div class="px-2 py-4 p-md-5 checkout-container w-100">
    <div class="checkout-content row h-100 gy-5">
        <div class="shopping-cart-container m-0 col-12 col-xl-8 h-100">
            <h1>Mi carrito</h1>
            <div class="products-container" *ngIf="order">
                <div class="product card pb-5 border-0 w-100 position-relative" >
                    <div class="row gy-3 h-100 align-items-center">
                        <div class="col-md-3" style="height: 140px;">
                            <img style="object-fit: contain;" class="img-fluid rounded" [src]="getItemImage(order.orderDetail[0]?.product.productImages)">
                        </div>
        
                        <div class="col-md-9 h-100">
                            <div class="card-body h-100 row gy-4">
                                <div class="col-12 col-md-5">
                                    <p class="card-title fs-md"><strong>{{order.orderDetail[0].productName}}</strong></p>
                                    <div>
                                        <p class="text-muted">Servicios Adicionales:</p>
                                        <p [hidden]="!order.orderDetail[0].addedDentalMonitoring">Dental Monitoring
                                            <u>{{order.orderDetail[0].dentalMonitoringPrice | currency}}</u>
                                        </p>
                                        <p [hidden]="!order.orderDetail[0].addedIsComplexCase">Caso Complejo
                                            <u>{{order.orderDetail[0].priceComplexCase | currency}}</u>
                                        </p>
                                        <p>
                                            <ng-container *ngIf="currentProduct?.hasUnlimitedAligners; else hasNotUnlimitedAligners">
                                                <span>¡Este producto tiene alineadores ilimitados!</span>
                                            </ng-container>
                                            <ng-template #hasNotUnlimitedAligners>
                                                <span
                                                    [hidden]="order.orderDetail[0].productExtraAlignersQuantity == 0">{{order.orderDetail[0].productExtraAlignersQuantity }}
                                                    Alineadores Extra <u>{{order.orderDetail[0].productExtraAlignersQuantity  *
                                                        order.orderDetail[0].productExtraAlignersPrice  | currency}}</u>
                                                </span>
                                            </ng-template>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-12 col-md-3">
                                    <p class="w-100 mt-md-auto text-end text-md-start"
                                        >
                                        {{order.orderDetail[0].productPrice | currency}}
                                    </p>
                                </div>
                                <div class="col-12 col-md-4 d-flex gap-2 align-items-center justify-content-end justify-content-md-start">
                                    <app-custom-input-number #customInputQuantity [minValue]="1" [counter]="order.orderDetail[0].quantity"
                                        [disabled]="true"></app-custom-input-number>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Payment Methods-->
        <div class="col-12 col-xl-4 h-100">
            <div class="h-100">
                <mat-card class="card-general h-100">
                    <mat-card-title>Método de pago</mat-card-title>
                    <mat-card-content>
                        <div class="d-flex flex-column justify-content-center gap-3">
                            <button [id]="item.name" class="button payment-button"
                                [ngClass]="{'active': paymentTypeSelected == item.type}"
                                (click)="paymentTypeSelected = item.type" *ngFor="let item of paymentTypeArray">

                                <img [src]="item.image" [alt]="item.name" />
                                <p class="text-muted">
                                    {{item.description}}
                                </p>
                                <span class="d-flex justify-content-center gap-2 mt-2 flex-wrap" *ngIf="item.type == 2">
                                    <span>
                                        <img class="height:150px;"
                                            src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/body/7%20Eleven.svg" />
                                    </span>
                                    <span>
                                        <img
                                            src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/body/Bodega%20Aurrera.svg" />
                                    </span>
                                    <span>
                                        <img
                                            src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/body/Farmacias%20del%20Ahorro.svg" />
                                    </span>
                                    <span>
                                        <img
                                            src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/body/Sam_s.svg" />
                                    </span>
                                    <span>
                                        <img
                                            src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/body/Waldo_s.svg" />
                                    </span>
                                    <span>
                                        <img
                                            src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/body/Walmart%20Express.svg" />
                                    </span>
                                    <span>
                                        <img
                                            src="https://aliwellstorageaccount.blob.core.windows.net/uploads/website-images/body/Walmart.svg" />
                                    </span>
                                </span>
                            </button>
                        </div>

                        <div class="p-2 rounded w-100 text-end mt-4" *ngIf="order">
                            <p>Subtotal: {{order.orderDetail[0].subtotal | currency}}</p>
                            <p>IVA: {{order.orderDetail[0].subtotalTax | currency}}</p>
                            <p>Total: {{order.orderDetail[0].total | currency}}</p>
                            <button (click)="onProcessPaymentType()" mat-button
                                class="button secondary-button lh-1 p-2 mt-2">Continuar
                                <mat-icon>chevron_right</mat-icon></button>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</div>